import { RootState } from 'reducers';

import * as c from '../../constants/UI';

const enabled = (state = false, { type }) => {
  switch (type) {
    case c.ENABLE_PRODUCT_EDIT_MODE:
      return true;
    case c.DISABLE_PRODUCT_EDIT_MODE:
      return false;
    default:
      return state;
  }
};

export default enabled;

export const getIsEditMode = (state: RootState) => state.UI.productEditMode;
